var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 2.5H14.7C11.5 2.5 9.5 4.5 9.5 7.7V11.75H13.94L11.87 9.68C11.72 9.53 11.65 9.34 11.65 9.15C11.65 8.96 11.72 8.77 11.87 8.62C12.16 8.33 12.64 8.33 12.93 8.62L16.28 11.97C16.57 12.26 16.57 12.74 16.28 13.03L12.93 16.38C12.64 16.67 12.16 16.67 11.87 16.38C11.58 16.09 11.58 15.61 11.87 15.32L13.94 13.25H9.5V17.3C9.5 20.5 11.5 22.5 14.7 22.5H17.29C20.49 22.5 22.49 20.5 22.49 17.3V7.7C22.5 4.5 20.5 2.5 17.3 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 11.75C2.84 11.75 2.5 12.09 2.5 12.5C2.5 12.91 2.84 13.25 3.25 13.25H9.5V11.75H3.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.2cd044c19c7768f0cfa00a743815c567.svg";
export { ForwardRef as ReactComponent };